import '@babel/polyfill';
import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import { router } from './routes';
import { store } from './store/store';
import axios from 'axios';
import './registerServiceWorker';
import Auth from './packages/auth/Auth';
import defineAbilitiesFor from './packages/ability/Ability';

Vue.config.productionTip = false;

Vue.use(Auth);

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + Vue.auth.getToken();

axios.defaults.baseURL = process.env.VUE_APP_API;

Vue.component('left-nav', require('./components/nav/LeftBar.vue').default);

window.defineAbilitiesFor = defineAbilitiesFor;

/**
 * Helper function for fill forms
 */
window.fillForm = function(formArray, model, method = 'POST'){
  let data = new FormData();
  data.append('_method', method);
  formArray.forEach(item => {
    data.append(item, (model[`${item}`] != undefined && model[`${item}`] != '')? model[`${item}`] : '');
  });
  return data;
};

router.beforeEach(
  (to, from, next) => {

    const abilities = defineAbilitiesFor(store.getters['ability/getPermissionList']);

    if(Vue.auth.isAuth() && abilities.rules.length == 0){
      /**
       * router if page is hard reload
       */
      axios.get(process.env.VUE_APP_API + 'user')
        .then(res => {
          store.dispatch('user/changeUser', res.data.user);
          store.dispatch('nav/setShowLeftBar', true);
          store.dispatch('ability/changePermissionList', res.data.permissions);

          defineAbilitiesFor(store.getters['ability/getPermissionList']);
          // this.loading = false;

          if(to.matched.some(record => record.meta.forVisitors)){
            if(Vue.auth.isAuth()){
              next({ path: "/home" });
            } else next();
          }
          else if(to.matched.some(record => record.meta.forAuth)){
            if(!Vue.auth.isAuth()){
              next({ path: "/login" });
            } else {
              if(to.matched.some(record => record.meta.group)){
                const abilities = defineAbilitiesFor(store.getters['ability/getPermissionList']);
                // const canNavigate = to.matched.some(route => {
                //   return abilities.can(route.meta.group, route.meta.guard_name)
                // });

                // if(!canNavigate) {
                //   next({ path: "/home" });
                // }
              }

              next();
            }
          }
          else next();

        })
        .catch(e => {
          if(e.response.status == 401){
            Vue.auth.destroyToken();
            router.push('/login');
          }
        });

    }else{
      /**
       * router if page is not hard reload
       */
      if(to.matched.some(record => record.meta.forVisitors)){
        if(Vue.auth.isAuth()){
          next({ path: "/home" });
        } else next();
      }
      else if(to.matched.some(record => record.meta.forAuth)){
        if(!Vue.auth.isAuth()){
          next({ path: "/login" });
        } else {
          if(to.matched.some(record => record.meta.group)){
            // const canNavigate = to.matched.some(route => {
            //   return abilities.can(route.meta.group, route.meta.guard_name)
            // });
            //
            // if(!canNavigate) {
            //   next({ path: "/home" });
            // }
          }

          next();
        }
      }
      else next();
    }
  }
);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
